export enum LabileBlood {
  rbc = "CGR",
  pads = "Plaquettes",
  plasma = "Plasma"
}
